import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

import colors from '../../../../styles/colors';

export const BlastCard = styled('div')({
  border: `1px solid ${colors.shades.gamma3}`,
  borderRadius: 12,
  padding: 16,
  marginTop: 16,
  '&:first-of-type': { marginTop: 0 },
});

export const BlastNumber = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 24,
  height: 24,
  borderRadius: 6,
  fontSize: 13,
  fontWeight: 700,
  color: colors.shades.beta2,
  backgroundColor: colors.base.primary,
});

export const Stepper = styled('div')({
  display: 'inline-flex',
  alignItems: 'center',
  border: `1px solid ${colors.shades.gamma3}`,
  borderRadius: 8,
  overflow: 'hidden',
});

export const StepperButton = styled('button')({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 28,
  height: 28,
  border: 'none',
  background: colors.base.gamma,
  cursor: 'pointer',
  fontSize: 16,
  lineHeight: 1,
  color: colors.shades.beta2,
  '&:disabled': { opacity: 0.4, cursor: 'not-allowed' },
  '&:hover:not(:disabled)': { background: colors.shades.primary7 },
});

export const StepperValue = styled('span')({
  minWidth: 36,
  textAlign: 'center',
  fontSize: 13,
  fontWeight: 600,
  color: colors.shades.beta2,
});

export const PreviewDayLabel = styled('div')({
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: 0.4,
  color: colors.shades.gamma10,
  marginBottom: 4,
});

export const PreviewBubble = styled(Box)({
  borderRadius: 12,
  padding: '10px 12px',
  backgroundColor: colors.base.gamma,
  border: `1px solid ${colors.shades.gamma3}`,
});
